import getServerSidePropsPage from 'root/src/client/util/getServerSidePropsPage'
import ClearRouteComponent from 'root/src/client/web/ClearRouteComponent'

const RulesOfUse = ClearRouteComponent

export const getServerSideProps = getServerSidePropsPage

export default RulesOfUse
